module.exports = __webpack_public_path__ + "img/hash.8339038b.svg";